export interface NavigationSettings {
  seasons: boolean;
  messages: boolean;
  parent_portal: boolean;
  parent_documents: boolean;
  form_templates: boolean;
  apparel: boolean;
  reporting: boolean;
  ai_content: boolean;
  makeup_classes: boolean;
  notifications: boolean;
  data_import: boolean;
  invoices: boolean;
  auto_billing: boolean;
  payments: boolean;
}

export const DEFAULT_NAVIGATION_SETTINGS: NavigationSettings = {
  seasons: true,
  messages: true,
  parent_portal: true,
  parent_documents: true,
  form_templates: true,
  apparel: true,
  reporting: true,
  ai_content: true,
  makeup_classes: true,
  notifications: true,
  data_import: true,
  invoices: true,
  auto_billing: true,
  payments: true,
};

export interface NavigationItem {
  key: keyof NavigationSettings;
  title: string;
  description: string;
  category: 'management' | 'financial' | 'communication' | 'data' | 'other';
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    key: 'seasons',
    title: 'Seasons',
    description: 'Organize classes into seasonal terms',
    category: 'management'
  },
  {
    key: 'makeup_classes',
    title: 'Makeup Classes',
    description: 'Manage makeup class scheduling',
    category: 'management'
  },
  {
    key: 'invoices',
    title: 'Invoices',
    description: 'Create and manage customer invoices',
    category: 'financial'
  },
  {
    key: 'auto_billing',
    title: 'Auto-Billing',
    description: 'Automated billing schedules and recurring payments',
    category: 'financial'
  },
  {
    key: 'payments',
    title: 'Payments',
    description: 'View payments and transaction history',
    category: 'financial'
  },
  {
    key: 'messages',
    title: 'Messages',
    description: 'Communication with families',
    category: 'communication'
  },
  {
    key: 'notifications',
    title: 'Notifications',
    description: 'Send announcements to families',
    category: 'communication'
  },
  {
    key: 'parent_portal',
    title: 'Parent Portal',
    description: 'Parent portal configuration',
    category: 'communication'
  },
  {
    key: 'parent_documents',
    title: 'Parent Documents',
    description: 'Manage documents for parents',
    category: 'communication'
  },
  {
    key: 'form_templates',
    title: 'Form Templates',
    description: 'Manage electronic form templates for automated document requests',
    category: 'communication'
  },
  {
    key: 'reporting',
    title: 'Reporting',
    description: 'Analytics and business reports',
    category: 'data'
  },
  {
    key: 'ai_content',
    title: 'AI Content',
    description: 'AI-powered content generation',
    category: 'data'
  },
  {
    key: 'data_import',
    title: 'Data Import',
    description: 'Import data from external systems',
    category: 'other'
  },
  {
    key: 'apparel',
    title: 'Apparel',
    description: 'Manage merchandise and apparel sales',
    category: 'other'
  },
];